module.exports = __webpack_public_path__ + "static/img/img5.b2fca67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/338/carousel/c01/img5.png
// module id = 9s4t
// module chunks = 0